/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useState, useEffect } from "react";
import { useToasts } from "react-toast-notifications";
import { FullPageLoadingContext } from "../../components/FullPageLoading";
import { LayoutContext } from "../../components/layout";
import { useHistory } from "react-router-dom";
import "./PatientEnrollment.scss";

const PatientEnrollment = () => {
  const history = useHistory();
  const { addToast } = useToasts();
  const { showFullPageLoading } = useContext(FullPageLoadingContext);
  const { currentLocation } = useContext(LayoutContext);
  const [patientEnrollmentLink, setPatientEnrollmentLink] = useState("");

  useEffect(() => {
    if (currentLocation?.enrollmentUrl) {
      setPatientEnrollmentLink(currentLocation.enrollmentUrl);
    }

    if (currentLocation?.enrollmentUrl === "") {
      addToast("No patient enrollment form was found.", {
        appearance: "error",
        timeout: 10000,
        autoDismiss: true,
      });
      history.push("/reports3");
    }
  }, [currentLocation]);

  useEffect(() => {
    showFullPageLoading(true);
    return () => {
      showFullPageLoading(false);
    };
  }, []);

  return (
    <>
      {patientEnrollmentLink && (
        <iframe
          id="patient-enrollment-container"
          src={patientEnrollmentLink}
          onLoad={() => showFullPageLoading(false)}
        />
      )}
    </>
  );
};

export default PatientEnrollment;
